export const blockIconsHouseholdHumidityHighNew = (
	<span className='material-symbols-outlined'>humidity_high</span>
);
